import * as React from 'react';

import uniqueId from 'lodash/uniqueId';

import {CopyButton} from '../button/copy-button/copy-button';
import {UppercaseLabel} from '../typography/uppercase-label';

import styles from './code-block.module.css';

type Props = {
    label?: string | React.ReactNode;
    name: string;
    value: string;
    includeCopyButton?: boolean;
    onCopy?: () => void;
    height?: number;
};

export function CodeBlock(props: Props) {
    const codeBlockRef = React.useRef(null);
    const idRef = React.useRef<string>(uniqueId('input_'));

    return (
        <>
            {props.label ? (
                // @ts-expect-error
                <UppercaseLabel htmlFor={idRef.current}>{props.label}</UppercaseLabel>
            ) : undefined}
            <div className={styles['code-block']}>
                <textarea
                    id={idRef.current}
                    name={props.name}
                    ref={codeBlockRef}
                    value={props.value}
                    onChange={() => {}}
                    spellCheck={false}
                    style={props.height ? {height: props.height} : undefined}
                />
                {props.includeCopyButton ? (
                    <div className={styles['copy-button']}>
                        <CopyButton
                            variant='primary'
                            target={codeBlockRef}
                            size='big'
                            onCopy={props.onCopy}
                        />
                    </div>
                ) : undefined}
            </div>
        </>
    );
}
